
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facebook-marketing-services",
      function () {
        return require("private-next-pages/facebook-marketing-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facebook-marketing-services"])
      });
    }
  